import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn, formatIntNumber } from '@anytag/shared-utils';

export interface ProfilePostsCountProps {
  className?: string;
  children?: ReactNode;
  count?: number | null;
  countLabel?: ReactNode;
  alwaysShow?: boolean;
}

export const ProfilePostsCount = ({
  count,
  children,
  className,
  countLabel,
  alwaysShow = false
}: ProfilePostsCountProps) => {
  const { t } = useTranslation();

  return count || alwaysShow ? (
    <div className={cn('box-border flex min-h-13 items-center bg-white px-4 py-2 shadow-container', className)}>
      <p className="flex-1 text-base leading-4.5">
        <span className="font-semibold">{formatIntNumber(count)}</span>
        &nbsp;
        {countLabel || t('Posts found')}
      </p>

      {children}
    </div>
  ) : null;
};
